module.exports = __webpack_public_path__ + "img/left.0d519eaa.webp";